import React from 'react';
import { useAlert } from '../contexts/AlertContext';

/**
 * 되돌릴 수 없는 동작 — 누르면 확인 모달(AlertContext.showConfirm — admin 과 같은 창)로 묻고, 「확인」이면 한다(2026-10-16).
 * 전엔 「4초 안에 한 번 더 누르기」였다(#108) — 무엇을 누른 건지 헷갈린다는 대표 피드백으로 확인창으로 바꿨다.
 */
export const ConfirmButton: React.FC<{
  onConfirm: () => void | Promise<unknown>;
  /** 평소 모양 — 아이콘이나 글자 */
  children: React.ReactNode;
  /** 확인창에 보일 말 — 「본문을 비웁니다」. 앞의 「한 번 더 — 」는 떼고 보인다 */
  ask: string;
  className?: string;
  /** 예전 두 번 누르기의 모양 — 쓰지 않는다(호출부 호환) */
  armedClassName?: string;
  title?: string;
  disabled?: boolean;
}> = ({ onConfirm, children, ask, className = '', title, disabled }) => {
  const { showConfirm } = useAlert();
  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      onClick={async (e) => {
        e.stopPropagation();
        if (await showConfirm(`${ask.replace(/^한 번 더\s*[—-]\s*/, '')}\n계속할까요?`)) void onConfirm();
      }}
      className={className}
    >
      {children}
    </button>
  );
};
